export function calculateSeoScore(blog) {
  const checks = []

  const title = blog.title || ''
  const content = blog.content || ''
  const meta = blog.meta_description || ''
  const metaTitle = blog.meta_title || ''
  const keyword = blog.focus_keyword || ''
  const slug = blog.slug || ''
  const words = content.trim().split(/\s+/).filter(Boolean).length

  // Title checks
  const titleLen = metaTitle.length || title.length
  checks.push({
    label: 'Title tag length (50–60 chars)',
    pass: titleLen >= 50 && titleLen <= 60,
    warn: titleLen > 40 && titleLen < 50,
  })

  checks.push({
    label: 'Focus keyword in title',
    pass: keyword && title.toLowerCase().includes(keyword.toLowerCase()),
    warn: false,
  })

  // Meta description
  checks.push({
    label: 'Meta description length (140–155 chars)',
    pass: meta.length >= 140 && meta.length <= 155,
    warn: meta.length > 120 && meta.length < 140,
  })

  checks.push({
    label: 'Keyword in meta description',
    pass: keyword && meta.toLowerCase().includes(keyword.toLowerCase()),
    warn: false,
  })

  // Content checks
  checks.push({
    label: 'Keyword in first 100 words',
    pass: keyword && content.toLowerCase().split(/\s+/).slice(0, 100).join(' ').includes(keyword.toLowerCase()),
    warn: false,
  })

  checks.push({
    label: 'Word count (1,500+ words)',
    pass: words >= 1500,
    warn: words >= 800 && words < 1500,
  })

  const h2count = (content.match(/^##\s/gm) || []).length
  checks.push({
    label: 'At least 4 subheadings (H2)',
    pass: h2count >= 4,
    warn: h2count >= 2 && h2count < 4,
  })

  const hasFaq = content.toLowerCase().includes('faq') || content.toLowerCase().includes('frequently asked')
  checks.push({
    label: 'FAQ section present',
    pass: hasFaq,
    warn: false,
  })

  const internalLinks = (content.match(/\(https?:\/\/(www\.)?thecobro\.com\/blog\//gi) || []).length
  checks.push({
    label: 'Internal links to thecobro.com/blog (min 2)',
    pass: internalLinks >= 2,
    warn: internalLinks === 1,
  })

  checks.push({
    label: 'URL slug is set',
    pass: slug.length > 3,
    warn: false,
  })

  const passCount = checks.filter(c => c.pass).length
  const warnCount = checks.filter(c => !c.pass && c.warn).length
  const score = Math.round((passCount / checks.length) * 100) + Math.round((warnCount / checks.length) * 5)

  return { checks, score: Math.min(score, 100), words }
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
}
